import { Box, Button, Grid, TextField, Typography, } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from "yup";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DoneIcon from '@mui/icons-material/Done';
import "./MeterReadingCorrectionForm.scss";
import { cfpBaseUrl } from '../../../network/urls';
import { useLocation } from 'react-router';
import { CircularProgress } from '@mui/material';
import { documentValidation, isImage, isPdf } from '../../../services/Functions';
import { documentExtensions } from '../../../utils/PortalName';
import {
    isLegacyReuploadDocumentEditable,
    LegacyServerDocumentPreview,
} from '../../../components/ReuploadDocuments/reuploadDocumentUi';

const MeterReadingCorrectionUpdateImages = () => {

    const initialValues = {
        // Required Documents Initial Values
        iv_off_peak_import: null,
        iv_peak_import: null,
        iv_off_peak_export: null,
        iv_peak_export: null,
    }
    // Documents states
    const [offPeakImportImg, setOffPeakImportImg] = useState('');
    const [peakImportImg, setPeakImportImg] = useState('');
    const [offPeakExportImg, setOffPeakExportImg] = useState('');
    const [peakExportImg, setPeakExportImg] = useState('');
    // Thumbnail states
    const [offPeakImportImgThumbnail, setOffPeakImportImgThumbnail] = useState('');
    const [peakImportImgThumbnail, setPeakImportImgThumbnail] = useState('');
    const [offPeakExportImgThumbnail, setOffPeakExportImgThumbnail] = useState('');
    const [peakExportImgThumbnail, setPeakExportImgThumbnail] = useState('');
    // File Name
    const [offPeakImportImgFileName, setOffPeakImportImgFileName] = useState('');
    const [peakImportImgFileName, setPeakImportImgFileName] = useState('');
    const [offPeakExportImgFileName, setOffPeakExportImgFileName] = useState('');
    const [peakExportImgFileName, setPeakExportImgFileName] = useState('');

    const [isLoadingSpinner, setIsLoadingSpinner] = useState(false)

    const { state } = useLocation();
    const { dialogRowData } = state;
    const [dialogRowDataLocal, setDialogRowDataLocal] = useState();
    const officeCode = parseInt(JSON.parse(window.localStorage.getItem('user-office-code')))
    const userHierarchy = parseInt(JSON.parse(window.localStorage.getItem('user-hierarchy')))
    const showAllApplicationsFlag = JSON.parse(window.localStorage.getItem('show-all-applications-flag'));
    let token = JSON.parse(window.localStorage.getItem('user-token'))

    const navigate = useNavigate();

    useEffect(() => {
        if (dialogRowData) {
            let dialogData = dialogRowData
            setDialogRowDataLocal(dialogData)
        }
    }, [dialogRowData])

    useEffect(() => {
        if (dialogRowData.offPeakImportImg) {
            mrcFormik.values.iv_off_peak_import = dialogRowData.offPeakImportImg
            setOffPeakImportImgThumbnail(dialogRowData.offPeakImportImg)
        }
        if (dialogRowData.peakImportImg) {
            mrcFormik.values.iv_peak_import = dialogRowData.peakImportImg
            setPeakImportImgThumbnail(dialogRowData.peakImportImg)
        }
        if (dialogRowData.offPeakExportImg) {
            mrcFormik.values.iv_off_peak_export = dialogRowData.offPeakExportImg
            setOffPeakExportImgThumbnail(dialogRowData.offPeakExportImg)
        }
        if (dialogRowData.peakExportImg) {
            mrcFormik.values.iv_peak_Export = dialogRowData.peakExportImg
            setPeakExportImgThumbnail(dialogRowData.peakExportImg)
        }
    }, [dialogRowData])

    const mrcFormik = useFormik({
        initialValues,
        validationSchema: Yup.object({
            // Required Documents Validation
            iv_off_peak_import: Yup.mixed().required('Please upload offpeak image in jpg, jpeg, png format.'),
            iv_peak_import: Yup.mixed().optional('Please upload last bill in jpg, jpeg, png format.'),
            iv_off_peak_export: Yup.mixed().optional('Please upload last bill in jpg, jpeg, png format.'),
            iv_peak_export: Yup.mixed().optional('Please upload last bill in jpg, jpeg, png format.'),

        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoadingSpinner(true);
            let userName = JSON.parse(window.localStorage.getItem('user-name'))


            var formdata = new FormData();
            formdata.append("complaintId", dialogRowData.complaintId);
            formdata.append("lastModifiedBy", userName);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;
            formdata.append("offPeakImportImg", offPeakImportImgThumbnail);
            formdata.append("peakImportImg", peakImportImgThumbnail);
            formdata.append("offPeakExportImg", offPeakExportImgThumbnail);
            formdata.append("peakExportImg", peakExportImgThumbnail);


            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "powerComplaints/updateImagesMeterReadingCorrection", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        var formdata = new FormData();
                        formdata.append("complaintId", dialogRowData.complaintId);
                        formdata.append("complaintObjectionStatus", 2);
                        formdata.append("complaintObjectionRemarks", "Documents Reuploaded");
                        formdata.append("complaintObjectionRemarksDetails", "-");
                        formdata.append("modifiedBy", userName);
                        const myHeaders = new Headers();
                        myHeaders.append("Authorization", token);;
                        var requestOptions = {
                            method: 'POST',
                            body: formdata,
                            headers: myHeaders,
                            redirect: 'follow',
                        };
                        fetch(cfpBaseUrl + "comman/changeComplaintsObjectionStatus", requestOptions)
                            .then(response => response.json())
                            .then(result => {
                                if (result.status === '200') {
                                    // toast.success(result.message);
                                    let lclStrdMrcConApp = JSON.parse(window.localStorage.getItem('meter-reading-complaints'));
                                    const index = lclStrdMrcConApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
                                    lclStrdMrcConApp[index].objectionStatus = 2
                                    window.localStorage.setItem('meter-reading-complaints', JSON.stringify(lclStrdMrcConApp));
                                    try {
                                        setIsLoadingSpinner(false)
                                    }
                                    catch (error) {
                                        console.log(error, 'Printing error')
                                    }
                                    setTimeout(() => {
                                        navigate('/meter-reading-correction-table')
                                    }, 2000)
                                }
                                else {
                                    // console.log(result.message)
                                }
                            })
                            .catch(error => console.log('error', error));
                    }
                    else {
                        setIsLoadingSpinner(false)
                        // console.log(result.message);
                    }
                })
                .catch(error => {
                    setIsLoadingSpinner(false)
                    console.log(error);
                });
        }
    })
    //Function to set states of documents


    const OffPeakImportImg = (event) => {
        // console.log('in applicant cnic functiuon')
        mrcFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            setOffPeakImportImgFileName(fileName)
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            // console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "OffPeakImportImg." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setOffPeakImportImg(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setOffPeakImportImgThumbnail(e.target.result);
                    // setPropertyDocumentsBase64(e.target.result.split(',')[1])
                };

                reader.readAsDataURL(file);

            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const PeakImportImg = (event) => {
        // console.log('in applicant cnic functiuon')
        mrcFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            setPeakImportImgFileName(fileName)
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            // console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "PeakImportImg." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setPeakImportImg(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setPeakImportImgThumbnail(e.target.result);
                    // setPropertyDocumentsBase64(e.target.result.split(',')[1])
                };

                reader.readAsDataURL(file);

            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const OffPeakExportImg = (event) => {
        // console.log('in applicant cnic functiuon')
        mrcFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            setOffPeakExportImgFileName(fileName)
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            // console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "OffPeakExportImg." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setOffPeakExportImg(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setOffPeakExportImgThumbnail(e.target.result);
                    // setPropertyDocumentsBase64(e.target.result.split(',')[1])
                };

                reader.readAsDataURL(file);

            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const PeakExportImg = (event) => {
        // console.log('in applicant cnic functiuon')
        mrcFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            setPeakExportImgFileName(fileName)
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            // console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "PeakExportImg." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setPeakExportImg(renamedFile);
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setPeakExportImgThumbnail(e.target.result);
                    // setPropertyDocumentsBase64(e.target.result.split(',')[1])
                };

                reader.readAsDataURL(file);

            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    return (
        <Grid container className='meter-change-request'>
            <Box className='mcContainer'>
                <Typography variant='h6' className='heading'>
                    Meter Reading Correction Update
                </Typography>
                {/* <Box className="progressBarBackground" >
                    <Box className="progressBarContainer">
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    offPeakImportImg
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>1</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Last Paid Bill</Typography>
                        </Box>
                        {
                            meterChangeType == 3 &&
                            <Box className="pbDocGroup">
                                <Typography className="badge">
                                    {
                                        policeReport
                                            ?
                                            <Box className='backgroundAttached'>
                                                <DoneIcon className='icon' />
                                            </Box> :
                                            <p className='backgroundUnAttached'>2</p>
                                    }
                                </Typography>
                                <Typography className='badgeText'>Police Report</Typography>
                            </Box>
                        }
                    </Box>
                </Box> */}
                <form className='ncform'>
                    <Typography variant="h6" className='groupTitle' >
                        Application Details
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <Typography className='fieldLabel' > Complaint Id</Typography>
                            <TextField
                                required
                                type='text'
                                name="iv_applied_load"
                                value={dialogRowData.complaintId}
                                disabled
                                id="iv_applied_load"
                                className='textInputField'
                            />
                        </Grid>
                    </Grid>
                    <Typography variant="h6" className='groupTitle'>
                        Images
                    </Typography>
                    <Grid container spacing={1} className='documentsContainer' >
                        <Grid item lg='1.5' >
                            <Typography className='documentLabel' >1- Off Peak Import.</Typography>
                            <Box className='documentError'>{((mrcFormik.errors.iv_off_peak_import && mrcFormik.touched.iv_off_peak_import)) ? (mrcFormik.errors.iv_off_peak_import) : null}</Box>
                        </Grid>
                        <Grid item lg='1.5'>
                            {
                                dialogRowData.offPeakImportImg ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <LegacyServerDocumentPreview
                                                thumbnail={offPeakImportImgThumbnail}
                                                flag={dialogRowData.offPeakImportImgFlag}
                                                alt="Off Peak Import"
                                            />
                                        </Grid>
                                        {
                                            isLegacyReuploadDocumentEditable(dialogRowData.offPeakImportImgFlag) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                    Change
                                                    <input hidden accept={documentExtensions} id='iv_off_peak_import' name='iv_off_peak_import' type="file" onChange={OffPeakImportImg} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    offPeakImportImg ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setOffPeakImportImg('') }} />}  >
                                                {offPeakImportImgThumbnail && <img src={offPeakImportImgThumbnail} alt="Applicant CNIC" width="50" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />} className='btn'>
                                                Front
                                                <input hidden accept={documentExtensions} id='iv_off_peak_import' name='iv_off_peak_import' type="file" onChange={OffPeakImportImg} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='1.5' >
                            <Typography className='documentLabel' >2- Peak Import.</Typography>
                            <Box className='documentError'>{((mrcFormik.errors.iv_peak_import && mrcFormik.touched.iv_peak_import)) ? (mrcFormik.errors.iv_peak_import) : null}</Box>
                        </Grid>
                        <Grid item lg='1.5'>
                            {
                                dialogRowData.peakImportImg ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <LegacyServerDocumentPreview
                                                thumbnail={peakImportImgThumbnail}
                                                flag={dialogRowData.peakImportImgFlag}
                                                alt="Peak Import"
                                            />
                                        </Grid>
                                        {
                                            isLegacyReuploadDocumentEditable(dialogRowData.peakImportImgFlag) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                    Change
                                                    <input hidden accept={documentExtensions} id='iv_peak_import' name='iv_peak_import' type="file" onChange={PeakImportImg} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    peakImportImg ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setPeakImportImg('') }} />}  >
                                                {peakImportImgThumbnail && <img src={peakImportImgThumbnail} alt="Peak Import" width="50" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />} className='btn'>
                                                Front
                                                <input hidden accept={documentExtensions} id='iv_peak_import' name='iv_peak_import' type="file" onChange={PeakImportImg} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='1.5' >
                            <Typography className='documentLabel' >3- Off Peak Export.</Typography>
                            <Box className='documentError'>{((mrcFormik.errors.iv_off_peak_export && mrcFormik.touched.iv_off_peak_export) ? (mrcFormik.errors.iv_off_peak_export) : null)}</Box>
                        </Grid>
                        <Grid item lg='1.5'>
                            {
                                dialogRowData.offPeakExportImg ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <LegacyServerDocumentPreview
                                                thumbnail={offPeakExportImgThumbnail}
                                                flag={dialogRowData.offPeakExportImgFlag}
                                                alt="Off Peak Export"
                                            />
                                        </Grid>
                                        {
                                            isLegacyReuploadDocumentEditable(dialogRowData.offPeakExportImgFlag) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                    Change
                                                    <input hidden accept={documentExtensions} id='iv_off_peak_export' name='iv_off_peak_export' type="file" onChange={OffPeakExportImg} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    offPeakExportImg ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setOffPeakExportImg('') }} />}  >
                                                {offPeakExportImgThumbnail && <img src={offPeakExportImgThumbnail} alt="Off Peak Export" width="50" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />} className='btn'>
                                                Front
                                                <input hidden accept={documentExtensions} id='iv_off_peak_export' name='iv_off_peak_export' type="file" onChange={OffPeakExportImg} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='1.5' >
                            <Typography className='documentLabel' >4- Peak Export.</Typography>
                            <Box className='documentError'>{((mrcFormik.errors.iv_off_peak_export && mrcFormik.touched.iv_off_peak_export) ? (mrcFormik.errors.iv_off_peak_export) : null)}</Box>
                        </Grid>
                        <Grid item lg='1.5'>
                            {
                                dialogRowData.peakExportImg ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <LegacyServerDocumentPreview
                                                thumbnail={peakExportImgThumbnail}
                                                flag={dialogRowData.peakExportImgFlag}
                                                alt="Peak Export"
                                            />
                                        </Grid>
                                        {
                                            isLegacyReuploadDocumentEditable(dialogRowData.peakExportImgFlag) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                    Change
                                                    <input hidden accept={documentExtensions} id='iv_peak_export' name='iv_peak_export' type="file" onChange={PeakExportImg} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    peakExportImg ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setPeakExportImg('') }} />}  >
                                                {peakExportImgThumbnail && <img src={peakExportImgThumbnail} alt="Peak Export" width="50" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />} className='btn'>
                                                Front
                                                <input hidden accept={documentExtensions} id='iv_peak_export' name='iv_peak_export' type="file" onChange={PeakExportImg} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                    </Grid>
                    <Box sx={{ marginTop: '18%', textAlign: 'right' }}>
                        <Button sx={{ width: '10%', marginLeft: '1%', marginBottom: '1%' }} variant="contained" component="label" type='submit' onClick={mrcFormik.handleSubmit} disabled={isLoadingSpinner}>
                            {isLoadingSpinner ? (
                                <Box sx={{ display: 'flex' }}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                'Submit'
                            )}
                        </Button>
                        < ToastContainer autoClose={5000} style={{ width: '50%' }} theme="colored" />
                    </Box>
                </form >
            </Box >
        </Grid >
    )
}

export default MeterReadingCorrectionUpdateImages
